
<div class="upload-container independent">
  <slot name="uploadContainer"></slot>

  <div class="upload-list">
    <slot name="listContainer"></slot>
  </div>
</div>
